var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon",class:{'is-inline': _vm.inline}},[_c('i',{class:( _obj = {}, _obj[_vm.clsIcon] = true, _obj )}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }